import { combineReducers } from 'redux';
import * as ActionTypes from './actionTypes';

const PROFILE_INITIAL_STATE = {
  fake_username: null,
  username: null,
  name: null,
  email: null,
  admin: null,
  token: null,
  staff: null,
};

function profile(state = PROFILE_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.LOGOUT:
      return Object.assign({}, state, PROFILE_INITIAL_STATE);
    case ActionTypes.UPDATE_PROFILE:
      return Object.assign({}, state, action.params);
    default:
      return state;
  }
}

export const userReducer = combineReducers({
  profile,
});



// WEBPACK FOOTER //
// ./src/reducers.js